export default [
    {
        "error_id": "SCRS-01",
        "data": [
            {
                "cross_section": "43002",
                "schematic": "43009.00",
                "assigned": "43002.00",
                "channel": 792,
                "difference": "7.00"
            },
            {
                "cross_section": "42210",
                "schematic": "42217.00",
                "assigned": "42210.00",
                "channel": 53,
                "difference": "7.00"
            },
            {
                "cross_section": "42157",
                "schematic": "42164.00",
                "assigned": "42157.00",
                "channel": 95,
                "difference": "7.00"
            },
            {
                "cross_section": "42062",
                "schematic": "42069.00",
                "assigned": "42062.00",
                "channel": 365,
                "difference": "7.00"
            },
            {
                "cross_section": "41697",
                "schematic": "41704.00",
                "assigned": "41697.00",
                "channel": 652,
                "difference": "7.00"
            },
            {
                "cross_section": "41045",
                "schematic": "41052.00",
                "assigned": "41045.00",
                "channel": 630,
                "difference": "7.00"
            },
            {
                "cross_section": "40415",
                "schematic": "40422.00",
                "assigned": "40415.00",
                "channel": 728,
                "difference": "7.00"
            },
            {
                "cross_section": "39687",
                "schematic": "39694.00",
                "assigned": "39687.00",
                "channel": 482,
                "difference": "7.00"
            },
            {
                "cross_section": "39205",
                "schematic": "39212.00",
                "assigned": "39205.00",
                "channel": 764,
                "difference": "7.00"
            },
            {
                "cross_section": "38441",
                "schematic": "38448.00",
                "assigned": "38441.00",
                "channel": 399,
                "difference": "7.00"
            },
            {
                "cross_section": "38042",
                "schematic": "38049.00",
                "assigned": "38042.00",
                "channel": 152,
                "difference": "7.00"
            },
            {
                "cross_section": "37890",
                "schematic": "37897.00",
                "assigned": "37890.00",
                "channel": 60,
                "difference": "7.00"
            },
            {
                "cross_section": "37830",
                "schematic": "37837.00",
                "assigned": "37830.00",
                "channel": 458,
                "difference": "7.00"
            },
            {
                "cross_section": "37372",
                "schematic": "37379.00",
                "assigned": "37372.00",
                "channel": 430,
                "difference": "7.00"
            },
            {
                "cross_section": "36942",
                "schematic": "36949.00",
                "assigned": "36942.00",
                "channel": 669,
                "difference": "7.00"
            },
            {
                "cross_section": "36273",
                "schematic": "36280.00",
                "assigned": "36273.00",
                "channel": 236,
                "difference": "7.00"
            },
            {
                "cross_section": "36037",
                "schematic": "36044.00",
                "assigned": "36037.00",
                "channel": 112,
                "difference": "7.00"
            },
            {
                "cross_section": "35925",
                "schematic": "35932.00",
                "assigned": "35925.00",
                "channel": 332,
                "difference": "7.00"
            },
            {
                "cross_section": "35593",
                "schematic": "35600.00",
                "assigned": "35593.00",
                "channel": 337,
                "difference": "7.00"
            },
            {
                "cross_section": "35256",
                "schematic": "35263.00",
                "assigned": "35256.00",
                "channel": 754,
                "difference": "7.00"
            },
            {
                "cross_section": "34502",
                "schematic": "34509.00",
                "assigned": "34502.00",
                "channel": 504,
                "difference": "7.00"
            },
            {
                "cross_section": "33998",
                "schematic": "34005.00",
                "assigned": "33998.00",
                "channel": 683,
                "difference": "7.00"
            },
            {
                "cross_section": "33315",
                "schematic": "33322.00",
                "assigned": "33315.00",
                "channel": 942,
                "difference": "7.00"
            },
            {
                "cross_section": "32373",
                "schematic": "32380.00",
                "assigned": "32373.00",
                "channel": 700,
                "difference": "7.00"
            },
            {
                "cross_section": "31673",
                "schematic": "31680.00",
                "assigned": "31673.00",
                "channel": 646,
                "difference": "7.00"
            },
            {
                "cross_section": "31027",
                "schematic": "31034.00",
                "assigned": "31027.00",
                "channel": 564,
                "difference": "7.00"
            },
            {
                "cross_section": "30463",
                "schematic": "30470.00",
                "assigned": "30463.00",
                "channel": 291,
                "difference": "7.00"
            },
            {
                "cross_section": "30172",
                "schematic": "30179.00",
                "assigned": "30172.00",
                "channel": 282,
                "difference": "7.00"
            },
            {
                "cross_section": "29890",
                "schematic": "29897.00",
                "assigned": "29890.00",
                "channel": 521,
                "difference": "7.00"
            },
            {
                "cross_section": "29369",
                "schematic": "29376.00",
                "assigned": "29369.00",
                "channel": 1175,
                "difference": "7.00"
            },
            {
                "cross_section": "28194",
                "schematic": "28201.00",
                "assigned": "28194.00",
                "channel": 891,
                "difference": "7.00"
            },
            {
                "cross_section": "27303",
                "schematic": "27310.00",
                "assigned": "27303.00",
                "channel": 1075,
                "difference": "7.00"
            },
            {
                "cross_section": "26228",
                "schematic": "26235.00",
                "assigned": "26228.00",
                "channel": 1112,
                "difference": "7.00"
            },
            {
                "cross_section": "25116",
                "schematic": "25123.00",
                "assigned": "25116.00",
                "channel": 1395,
                "difference": "7.00"
            },
            {
                "cross_section": "23721",
                "schematic": "23728.00",
                "assigned": "23721.00",
                "channel": 238,
                "difference": "7.00"
            },
            {
                "cross_section": "23483",
                "schematic": "23490.00",
                "assigned": "23483.00",
                "channel": 1571,
                "difference": "7.00"
            },
            {
                "cross_section": "21912",
                "schematic": "21919.00",
                "assigned": "21912.00",
                "channel": 1066,
                "difference": "7.00"
            },
            {
                "cross_section": "20846",
                "schematic": "20853.00",
                "assigned": "20846.00",
                "channel": 1156,
                "difference": "7.00"
            },
            {
                "cross_section": "19690",
                "schematic": "19697.00",
                "assigned": "19690.00",
                "channel": 1610,
                "difference": "7.00"
            },
            {
                "cross_section": "18080",
                "schematic": "18087.00",
                "assigned": "18080.00",
                "channel": 922,
                "difference": "7.00"
            },
            {
                "cross_section": "17158",
                "schematic": "17165.00",
                "assigned": "17158.00",
                "channel": 642,
                "difference": "7.00"
            },
            {
                "cross_section": "16516",
                "schematic": "16523.00",
                "assigned": "16516.00",
                "channel": 1056,
                "difference": "7.00"
            },
            {
                "cross_section": "15460",
                "schematic": "15467.00",
                "assigned": "15460.00",
                "channel": 2232,
                "difference": "7.00"
            },
            {
                "cross_section": "13228",
                "schematic": "13235.00",
                "assigned": "13228.00",
                "channel": 883,
                "difference": "7.00"
            },
            {
                "cross_section": "12345",
                "schematic": "12352.00",
                "assigned": "12345.00",
                "channel": 590,
                "difference": "7.00"
            },
            {
                "cross_section": "11755",
                "schematic": "11762.00",
                "assigned": "11755.00",
                "channel": 1189,
                "difference": "7.00"
            },
            {
                "cross_section": "10566",
                "schematic": "10573.00",
                "assigned": "10566.00",
                "channel": 933,
                "difference": "7.00"
            },
            {
                "cross_section": "9633",
                "schematic": "9640.00",
                "assigned": "9633.00",
                "channel": 1231,
                "difference": "7.00"
            },
            {
                "cross_section": "8402",
                "schematic": "8409.00",
                "assigned": "8402.00",
                "channel": 1119,
                "difference": "7.00"
            },
            {
                "cross_section": "7283",
                "schematic": "7290.00",
                "assigned": "7283.00",
                "channel": 871,
                "difference": "7.00"
            },
            {
                "cross_section": "6412",
                "schematic": "6419.00",
                "assigned": "6412.00",
                "channel": 1806,
                "difference": "7.00"
            },
            {
                "cross_section": "4606",
                "schematic": "4613.00",
                "assigned": "4606.00",
                "channel": 856,
                "difference": "7.00"
            },
            {
                "cross_section": "3757",
                "schematic": "3757.00",
                "assigned": "3757.00",
                "channel": 980,
                "difference": "0.00"
            },
            {
                "cross_section": "2777",
                "schematic": "2777.00",
                "assigned": "2777.00",
                "channel": 544,
                "difference": "0.00"
            },
            {
                "cross_section": "2233",
                "schematic": "2233.00",
                "assigned": "2233.00",
                "channel": 255,
                "difference": "0.00"
            },
            {
                "cross_section": "1982",
                "schematic": "1978.00",
                "assigned": "1982.00",
                "channel": 164,
                "difference": "-4.00"
            },
            {
                "cross_section": "1814",
                "schematic": "1814.00",
                "assigned": "1814.00",
                "channel": 578,
                "difference": "0.00"
            },
            {
                "cross_section": "1236",
                "schematic": "1236.00",
                "assigned": "1236.00",
                "difference": 0
            }
        ]
    }
]